import {
	Component,
	OnInit,
	Input,
	ViewChild,
	Output,
	ViewEncapsulation,
	EventEmitter,
	OnDestroy
} from "@angular/core";
import { IdService } from "../shared/services/id.service";


@Component({
	selector: "rbc-speech",
	template: `
		<section [id]="id" class="list-divider-item">
			<div class="row">
				<div
					*ngIf="speaker"
					[id]="id + 'Speaker'"
					class="col-sm-3 strong"
				>
					{{ speaker }}
				</div>
				<div class="col-sm-9">
					<ng-content></ng-content>
				</div>
			</div>
		</section>
	`,
	styles: [],
	encapsulation: ViewEncapsulation.None
})
export class SpeechComponent {
	@Input() speaker: string;
	@Input() id;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}
}
